import { cbi_consumption_unit_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiConsumptionUnitEnum = (enumValue: cbi_consumption_unit_enum) => {
  switch (enumValue) {
    case cbi_consumption_unit_enum.GJ:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-GJ" />;
    case cbi_consumption_unit_enum.J:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-J" />;
    case cbi_consumption_unit_enum.KG:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-KG" />;
    case cbi_consumption_unit_enum.KJ:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-KJ" />;
    case cbi_consumption_unit_enum.KWH:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-KWH" />;
    case cbi_consumption_unit_enum.L:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-L" />;
    case cbi_consumption_unit_enum.M2:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-M2" />;
    case cbi_consumption_unit_enum.M3:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-M3" />;
    case cbi_consumption_unit_enum.MJ:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-MJ" />;
    case cbi_consumption_unit_enum.MWH:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-MWH" />;
    case cbi_consumption_unit_enum.T:
      return <Trans i18nKey="Enum_CbiConsumptionUnitEnum-T" />;
  }
};

export const translateCbiConsumptionUnitEnum_dynamic = (enumValue: cbi_consumption_unit_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_consumption_unit_enum.GJ:
      return t('Enum_CbiConsumptionUnitEnum-GJ');
    case cbi_consumption_unit_enum.J:
      return t('Enum_CbiConsumptionUnitEnum-J');
    case cbi_consumption_unit_enum.KG:
      return t('Enum_CbiConsumptionUnitEnum-KG');
    case cbi_consumption_unit_enum.KJ:
      return t('Enum_CbiConsumptionUnitEnum-KJ');
    case cbi_consumption_unit_enum.KWH:
      return t('Enum_CbiConsumptionUnitEnum-KWH');
    case cbi_consumption_unit_enum.L:
      return t('Enum_CbiConsumptionUnitEnum-L');
    case cbi_consumption_unit_enum.M2:
      return t('Enum_CbiConsumptionUnitEnum-M2');
    case cbi_consumption_unit_enum.M3:
      return t('Enum_CbiConsumptionUnitEnum-M3');
    case cbi_consumption_unit_enum.MJ:
      return t('Enum_CbiConsumptionUnitEnum-MJ');
    case cbi_consumption_unit_enum.MWH:
      return t('Enum_CbiConsumptionUnitEnum-MWH');
    case cbi_consumption_unit_enum.T:
      return t('Enum_CbiConsumptionUnitEnum-T');
  }
};
